import { render, staticRenderFns } from "./the-navigation.vue?vue&type=template&id=2ede8916&scoped=true"
import script from "./the-navigation.vue?vue&type=script&lang=js"
export * from "./the-navigation.vue?vue&type=script&lang=js"
import style0 from "./the-navigation.vue?vue&type=style&index=0&id=2ede8916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ede8916",
  null
  
)

export default component.exports